var _g, _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLicence = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_940_424)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 5.5,
    width: 17,
    height: 10,
    rx: 0.5,
    fill: "#7B7DFC",
    stroke: "#374BE3",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.08208 12.2743C5.07798 12.4239 4.99821 12.5469 4.90371 12.5475L2.19144 12.5808C2.08513 12.5814 1.99931 12.4504 2 12.2913C2.0007 12.1319 2.08784 12 2.19443 12H4.91823C5.01287 12 5.08611 12.1246 5.08201 12.2743H5.08208Z",
    fill: "#94A0FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6403 13.3226C15.6362 13.4722 15.5576 13.5902 15.4644 13.5907L9.92701 13.6214C9.82216 13.6221 9.73759 13.5 9.73829 13.3409C9.73898 13.1816 9.82494 13.0586 9.93 13.0586H15.4788C15.5721 13.0586 15.6443 13.1729 15.6403 13.3226Z",
    fill: "#94A0FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6405 12.2874C15.6364 12.437 15.5574 12.5539 15.4639 12.5545L9.90434 12.5847C9.79907 12.5853 9.71415 12.465 9.71485 12.3059C9.71554 12.1466 9.80184 12.0254 9.90733 12.0254H15.4783C15.572 12.0254 15.6446 12.1377 15.6405 12.2874Z",
    fill: "#94A0FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.7508 13.4216C6.7467 13.5466 6.60801 13.6489 6.44075 13.6502L2.31812 13.6947C2.14134 13.6962 1.99883 13.5931 2.00001 13.4644L2.00015 13.4499C2.0014 13.3211 2.14614 13.2156 2.32326 13.2145L6.45548 13.1826C6.62309 13.1817 6.75539 13.2824 6.75129 13.4074L6.7508 13.4215V13.4216Z",
    fill: "#94A0FF"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.976 2.45941C10.956 2.15781 10.7694 1.89049 10.4898 1.76086L6.8667 0.0806767C6.6347 -0.0268922 6.36542 -0.0268922 6.1333 0.0806767L2.51019 1.76086C2.23058 1.89049 2.04401 2.15781 2.02397 2.45941C1.68412 7.5888 5.0524 9.4578 6.15662 9.92982C6.37562 10.0234 6.62438 10.0234 6.84338 9.92982C7.9476 9.45768 11.3159 7.5888 10.976 2.45941Z",
    fill: "#EC8079"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.40521 0.776747C5.39064 0.776747 5.37667 0.768801 5.36999 0.755044C5.36076 0.736068 5.36902 0.713416 5.38845 0.704402L6.24452 0.307453C6.26396 0.298321 6.28716 0.306504 6.29639 0.32548C6.30562 0.344455 6.29736 0.367108 6.27793 0.376121L5.42186 0.773071C5.41651 0.775562 5.4108 0.776747 5.40521 0.776747Z",
    fill: "#F8C96A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.30231 3.54524C2.28142 3.54524 2.26417 3.529 2.26344 3.50848C2.25202 3.17533 2.25798 2.82796 2.2813 2.47584C2.29526 2.26545 2.42559 2.0783 2.62151 1.98745L5.05879 0.857206C5.07822 0.848192 5.10142 0.856257 5.11065 0.875233C5.11988 0.894208 5.11163 0.916861 5.09219 0.925874L2.65492 2.05612C2.4845 2.13522 2.37106 2.29782 2.35903 2.48082C2.33583 2.83045 2.32988 3.17533 2.3413 3.50599C2.34203 3.52698 2.32514 3.54465 2.30365 3.54524C2.30316 3.54524 2.30267 3.54524 2.30231 3.54524Z",
    fill: "#F8C96A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1001 2.65997C10.0961 2.58347 10.0494 2.51528 9.9786 2.48242L6.59161 0.911704C6.53379 0.884901 6.46662 0.884901 6.40881 0.911704L3.02181 2.48242C2.951 2.51528 2.90436 2.58359 2.90035 2.65997C2.80014 4.57344 3.25283 6.16989 4.24664 7.40723C5.00433 8.35068 5.89064 8.85615 6.41014 9.09205C6.46735 9.11802 6.53318 9.11802 6.59039 9.09205C7.10977 8.85615 7.9962 8.35057 8.75389 7.40723C9.7477 6.16989 10.2004 4.57332 10.1002 2.65997H10.1001Z",
    fill: "#F8C96A"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_940_424"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 10.95,
    fill: "white",
    transform: "translate(0 5)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLicence);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/licence.4955ac7e0ecaead9a8fcee89ef043ead.svg";